export const API_LANGUAGE_MAPPING = {
    cs: 'cs-CZ',
    en: 'en-GB',
}
